import { render } from "./DashboardTabsMobile.vue?vue&type=template&id=73a4f6f3&scoped=true&ts=true"
import script from "./DashboardTabsMobile.vue?vue&type=script&lang=ts"
export * from "./DashboardTabsMobile.vue?vue&type=script&lang=ts"

import "./DashboardTabsMobile.vue?vue&type=style&index=0&id=73a4f6f3&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a4f6f3"]])

export default __exports__